import { computed } from 'vue';
import { useSettingsStore } from '@/store/settings/settingsStore';
import { useNotificationStore } from '@/store/notificationStore';
import { useFormStore } from '@/store/sitemapUrlsHistory/sitemapUrlsHistory';
import { GoogleAnalytics } from '@/services/analytics/googleAnalytics';

export default function useSettings() {
  const settingsStore = useSettingsStore();
  const notificationStore = useNotificationStore();
  const formStore = useFormStore();

  // Theme settings
  const toggleTheme = () => {
    settingsStore.setTheme();
  };

  const isThemeDark = () => {
    return settingsStore.getIsThemeDark;
  };

  const getThemeText = () => {
    return isThemeDark() ? 'Dark' : 'Light';
  };

  // Clear form store local storage
  const clearFormStoreLocalStorage = () => {
    formStore.clearBaseSitemapUrls();
    notificationStore.addSuccessNotification(
      'Form store local storage cleared successfully!'
    );
    GoogleAnalytics.settingStorageClear();
  };

  // Reactive computed property for Debug mode
  const debugMode = computed({
    get: () => settingsStore.getIsDebugMode,
    set: (value: boolean) => settingsStore.setUseDebugMode(value),
  });

  // Reactive computed property for Sitemap usage
  const sitemapMode = computed({
    get: () => settingsStore.getIsUseSitemap,
    set: (value: boolean) => settingsStore.setUseSitemap(value),
  });

  return {
    theme: { toggleTheme, isThemeDark, getThemeText },
    clearFormStoreLocalStorage,
    debugMode,
    sitemapMode,
  };
}